module.exports = __webpack_public_path__ + "static/media/Invest_In_Time.f8701fd1.jpg";